import React from "react";
import { Field } from "redux-form";
import PropTypes from "prop-types";
import { FormInput, PhoneNumberField } from "MODULES/shared/components/Forms";
import FormRow from "MODULES/shared/components/Forms/FormRow";
import { Col } from "react-bootstrap";
import { properCase } from "LIB/formatters/text";
import { CONTACT, WEBSITE } from "MODULES/companies/constants";
import { COMPANY, EMAIL, NAME } from "APP_ROOT/constants";
import RestrictedContactWarning from "MODULES/companies/shared/components/RestrictedContactWarning";

export default function CreateCompany({
  allowPortalPurchase = false,
  getFieldValue = () => {},
  handleEmail
}) {
  const requireContact =
    !allowPortalPurchase ||
    (allowPortalPurchase && !getFieldValue([COMPANY, WEBSITE].join("."))) ||
    [NAME, EMAIL].some(f => !!getFieldValue([CONTACT, f].join(".")));

  return (
    <div>
      <FormRow>
        <Col md={5}>
          <Field
            name="company.name"
            component={FormInput}
            label="Company Name"
            required
          />
        </Col>
        <Col md={4}>
          <Field
            name="company.website"
            component={FormInput}
            label={properCase(WEBSITE)}
          />
        </Col>
      </FormRow>
      <FormRow>
        <Col md={4}>
          <div className="form-group">
            <Field
              name="contact.name"
              component={FormInput}
              label="Contact Name"
              required={requireContact}
            />
          </div>
        </Col>
        <Col md={4}>
          <div className="form-group">
            <Field
              name="contact.email"
              component={FormInput}
              label="Contact Email"
              onChange={e => handleEmail(e.target.value)}
              required={requireContact}
            />
          </div>
        </Col>
        <Col md={4}>
          <PhoneNumberField
            name="contact.phone1"
            component={FormInput}
            label="Phone Number 1"
            type="tel"
          />
        </Col>
      </FormRow>
      <FormRow>
        <RestrictedContactWarning
          contact={getFieldValue([CONTACT, NAME].join("."))}
        />
      </FormRow>
    </div>
  );
}

CreateCompany.propTypes = {
  allowPortalPurchase: PropTypes.bool,
  getFieldValue: PropTypes.func,
  handleEmail: PropTypes.func
};



// WEBPACK FOOTER //
// ./app/modules/companies/shared/FindOrCreateCompanyToggle/CreateCompany.jsx